import React from 'react';

import PropTypes from 'prop-types';

import ErrorMediaLibraryPostModal from '@/components/pages/scheduler/medialibrary/ErrorMediaLibraryPostModal';
// Components
import { MediaLibraryScheduler } from '@/components/pages/scheduler/medialibrary/MediaLibraryScheduler';

export const MediaLibraryWrapper = ({
    mediaLibraryState,
    onDropMedia = () => {
        /** */
    },
    mediaLibraryError,
    toggleMediaLibraryError,
    isOpenMediaLibraryError,
    onDestroy = () => {
        /** */
    },
    onClose = () => {
        /** */
    },
    ...restProps
}) => {
    return (
        <>
            <MediaLibraryScheduler
                keyReloadUniqMediaIds={mediaLibraryState?.keyReloadUniqMediaIds ?? 'scheduler'}
                onDestroy={onDestroy}
                onClose={onClose}
                transitionInProgress={mediaLibraryState?.transitionInProgress}
                {...restProps}
            />
            <ErrorMediaLibraryPostModal
                isOpen={isOpenMediaLibraryError}
                toggle={toggleMediaLibraryError}
                mediaLibraryError={mediaLibraryError}
                callback={() => onDropMedia({ ...mediaLibraryState.activeMedia, isRetry: true })}
                isLoadingCallback={mediaLibraryState.isMediaLibraryPostingLoading}
            />
        </>
    );
};

MediaLibraryWrapper.propTypes = {
    mediaLibraryState: PropTypes.object,
    setMediaLibraryState: PropTypes.func,
    onDropMedia: PropTypes.func,
    toggleMediaLibraryError: PropTypes.func,
    isOpenMediaLibraryError: PropTypes.bool,
    transitionInProgress: PropTypes.bool,
    onDestroy: PropTypes.func,
    onClose: PropTypes.func
};
